module.exports = __webpack_public_path__ + "static/media/dm.3a68c10d.svg";